import React from 'react';
import { Container, Row, Col, Nav, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

export const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Our Projects", to: "/projects" },
    { label: "Get Started", to: "/get-started" },
  ];

  const contactInfo = [
    { 
      icon: "📍", 
      text: "1#64 Aguirre Ave., Pilar Village Phase V, Zone XI, Las Piñas City, Metro Manila, Philippines",
      breakpoint: true
    },
    { icon: "📧", text: "info@sari-sari.com", link: "mailto:info@sari-sari.com" },
    { icon: "📞", text: "09178135511", link: "tel:09178135511" },
  ];

  return (
    <footer className="text-light pt-5 pb-3" style={{ backgroundColor: "#132440" }}>
      <Container>
        <Row className="mb-4 mt-4">
          {/* Logo + intro */}
          <Col md={4} className="mb-4 mb-md-0">
            <Link to="/" className="text-decoration-none d-flex align-items-center mb-3">
              <img
                src="/img/nav head.png"
                alt="Logo"
                style={{ height: "55px", marginRight: "10px", filter: "invert(1)" }}
              />
            </Link>
            <p className="text-muted footer-text-large" style={{ maxWidth: '320px' }}>
              We build innovative solutions for a sustainable and connected future.
              Join us on our mission.
            </p>
          </Col>

          {/* Quick Links */}
          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="text-uppercase fw-bold mb-3 border-bottom border-secondary pb-2 footer-heading">
              Quick Links
            </h5>
            <Nav className="flex-column">
              {navLinks.map((item, index) => (
                <Nav.Link
                  key={index}
                  as="span"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    document.documentElement.scrollTo(0, 0);
                    document.body.scrollTo(0, 0);
                    navigate(item.to);
                    setTimeout(() => {
                      window.scrollTo(0, 0);
                      document.documentElement.scrollTo(0, 0);
                      document.body.scrollTo(0, 0);
                    }, 0);
                  }}
                  className="p-0 mb-3 text-white-50 footer-link-hover footer-text-medium"
                  style={{ cursor: "pointer" }}
                >
                  {item.label}
                </Nav.Link>
              ))}
            </Nav>
          </Col>

          {/* Contact Info */}
          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="text-uppercase fw-bold mb-3 border-bottom border-secondary pb-2 footer-heading">
              Contact Us
            </h5>
            <Nav className="flex-column">
              {contactInfo.map((item, index) => (
                <Nav.Item key={index} className="mb-3">
                  <a
                    href={item.link || '#'}
                    className="text-white-50 text-decoration-none footer-link-hover d-flex align-items-start footer-text-medium"
                    style={{ fontSize: '1.1rem' }}
                  >
                    <span className="me-2" style={{ fontSize: "1.3rem" }}>{item.icon}</span>

                    {/* Responsive address break */}
                    {item.breakpoint ? (
                      <span>
                        <span className="d-none d-md-inline">
                          {item.text}
                        </span>
                        <span className="d-inline d-md-none" style={{ whiteSpace: "pre-line" }}>
                          1#64 Aguirre Ave., Pilar Village Phase V{"\n"}
                          Zone XI, Las Piñas City{"\n"}
                          Metro Manila, Philippines
                        </span>
                      </span>
                    ) : (
                      item.text
                    )}

                  </a>
                </Nav.Item>
              ))}
            </Nav>
          </Col>

          {/* Contact Button */}
          <Col md={2}>
            <h5 className="text-uppercase fw-bold mb-3 border-bottom border-secondary pb-2 footer-heading">
              Stay Connected
            </h5>
            <Button
              variant="outline-light"
              className="rounded-pill px-4 fw-bold footer-text-medium"
              style={{ fontSize: '1.1rem' }}
            >
              Contact Us!
            </Button>
          </Col>

        </Row>

        <hr className="bg-secondary my-4" />

        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
            <p className="mb-0 text-muted footer-text-medium">
              &copy; {currentYear} Your Company Name. All Rights Reserved.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-4">
              <a href="#" className="text-white-50 hover-light"><FaFacebook size={26} /></a>
              <a href="#" className="text-white-50 hover-light"><FaTwitter size={26} /></a>
              <a href="#" className="text-white-50 hover-light"><FaInstagram size={26} /></a>
              <a href="#" className="text-white-50 hover-light"><FaLinkedin size={26} /></a>
            </div>
          </Col>
        </Row>
      </Container>

      <style jsx global>{`
        .footer-link-hover:hover {
          color: #fff !important;
          transition: 0.2s ease;
        }
        .hover-light:hover {
          color: #fff !important;
          transition: 0.2s ease;
        }
        .footer-heading {
          font-size: 1.25rem;
        }
        .footer-text-large {
          font-size: 1.1rem;
          line-height: 1.7;
        }
        .footer-text-medium {
          font-size: 1.15rem;
        }
      `}</style>
    </footer>
  );
};
